import { TimerLockOpenIcon } from './TimerLockOpenIcon';

/**
 * author: Colton Wiscombe
 * id DEA728EB-8545-4E23-B31B-C9B1AA2229FD
 * name timer-lock-open
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-lock-open.svg
 * tags
 * - Date / Time 
 * - Lock 
 */
export const StopwatchLockOpenIcon = TimerLockOpenIcon;
export default StopwatchLockOpenIcon